import React from "react";
import styles from "./Schedule.module.css";

import ScheduleHero from "../../Components/HeroComponent/ScheduleHero";
import CalendarBooking from "../../Components/CalenderBooking/CalendarBooking";
import InquiryChargeNote from "../../Components/InquiryChargeNote/InquiryChargeNote";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const Schedule = () => {
  return (
    <>
      <ScheduleHero />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CalendarBooking />
      </LocalizationProvider>

      <InquiryChargeNote />
    </>
  );
};

export default Schedule;
